import { jsx as _jsx } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useAuth } from "../../../../services/auth";
import { useTenancy } from "../../../../services/tenancy";
export default function StepContent({ step, modal, isDemo }) {
    var _a;
    const auth = useAuth();
    const tenancy = useTenancy();
    if (modal === true && ((_a = tenancy.client) === null || _a === void 0 ? void 0 : _a.domain) !== "naljepnice") {
        return null;
    }
    return (_jsx(Grid, Object.assign({ item: true, xs: 12, md: auth.isPublic || modal ? 12 : 8, lg: isDemo ? 10 : auth.isPublic || modal ? 12 : 8 }, { children: _jsx(Paper, { children: _jsx(Box, Object.assign({ sx: { padding: 4 } }, { children: _jsx(Typography, { dangerouslySetInnerHTML: {
                        __html: step.content,
                    } }) })) }) })));
}
